import { useQuery } from '@tanstack/react-query'

import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { QueryParams } from '../../common/types'
import { parseQueryParams } from '../../utilities/parsers'

const buildUrlWithParams = (baseUrl: string, params: QueryParams) => {
  return `${baseUrl}${parseQueryParams(params)}`
}

const fetchData = async (input: QueryParams) => {
  const url = buildUrlWithParams(apiUrl.SIGNATORIES, {
    ...input,
  })
  const response = await getData(url)
  return response
}

export const useSignatoryList = (input: QueryParams) => {
  return useQuery(['signatory_list', input], () => fetchData(input), {})
}
